import request from 'network/request';

export function getData(params) {
  return request({
    url: '/system/agreement/lookContent',
    method: 'get',
    params
  });
}
